<template>
  <v-dialog
    :value="value"
    width="420"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="text-subtitle-1">
        {{ schedule ? schedule.userName : '' }} の時間を設定
      </v-card-title>
      <v-card-text>
        <div class="d-flex align-center pt-1">
          <v-text-field
            v-model="startTime"
            type="time"
            label="出勤"
            dense
            hide-details
            class="me-4"
          />
          <v-text-field
            v-model="endTime"
            type="time"
            label="退勤"
            dense
            hide-details
          />
        </div>
        <p class="text-caption grey--text mt-3 mb-0">
          両方空にして保存すると「時間未定」に戻ります
        </p>
        <p
          v-if="error"
          class="error--text text-caption mt-2 mb-0"
        >
          {{ error }}
        </p>
      </v-card-text>
      <v-card-actions class="px-6 pb-4">
        <v-spacer></v-spacer>
        <v-btn
          text
          :disabled="submitting"
          @click="$emit('input', false)"
        >
          キャンセル
        </v-btn>
        <v-btn
          color="primary"
          :ripple="false"
          :loading="submitting"
          @click="save"
        >
          保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch, getCurrentInstance } from '@vue/composition-api'
import { format } from 'date-fns'
import WorkScheduleApi from '@/api/waiter/WorkSchedule'
import { buildShiftDateTime } from '@/views/waiter/shiftStaffingUtils'

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    // 対象シフト（{id, userName, startAt, endAt}）
    schedule: {
      type: Object,
      default: null,
    },
    // 営業日（yyyy-MM-dd）。深夜跨ぎの翌日補正に使う
    date: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy

    const startTime = ref('')
    const endTime = ref('')
    const error = ref('')
    const submitting = ref(false)

    watch(() => props.value, isOpen => {
      if (!isOpen) return
      startTime.value = props.schedule?.startAt ? format(new Date(props.schedule.startAt), 'HH:mm') : ''
      endTime.value = props.schedule?.endAt ? format(new Date(props.schedule.endAt), 'HH:mm') : ''
      error.value = ''
    })

    const save = async () => {
      error.value = ''
      const hasStart = startTime.value !== ''
      const hasEnd = endTime.value !== ''
      if (hasStart !== hasEnd) {
        error.value = '出勤と退勤はセットで入力してください'

        return
      }

      const payload = { id: props.schedule.id }
      if (hasStart && hasEnd) {
        payload.startAt = buildShiftDateTime(props.date, startTime.value)
        payload.endAt = buildShiftDateTime(props.date, endTime.value, startTime.value)
      } else {
        // 両方空 → 時間未定に戻す
        payload.startAt = ''
        payload.endAt = ''
      }

      submitting.value = true
      try {
        await WorkScheduleApi.updateWorkSchedule(payload)
        vm.$toast.success('時間を更新しました')
        emit('input', false)
        emit('saved')
      } catch (e) {
        const message = e?.response?.data?.message
        error.value = Array.isArray(message) ? message.join('、') : '時間の更新に失敗しました'
      } finally {
        submitting.value = false
      }
    }

    return {
      startTime,
      endTime,
      error,
      submitting,
      save,
    }
  },
}
</script>
